import React, { useState } from 'react'

const LongText = ({ text = 'LongText', maxLength = 300 }) => {
  const [showMore, setShowMore] = useState(false)

  if (text.length <= maxLength) {
    return <span>{text}</span>
  }
  if (showMore) {
    return (
      <span>
        {text} &nbsp;
        <span
          className="show-more"
          onClick={() => {
            setShowMore(false)
          }}
        >
          Ver menos
        </span>
      </span>
    )
  }

  if (text.length > maxLength) {
    return (
      <span>
        {text.substring(0, maxLength)}...&nbsp;
        <span
          className="show-more"
          onClick={() => {
            setShowMore(true)
          }}
        >
          Ver más
        </span>
      </span>
    )
  }
}

export default LongText
